import React from 'react';
import Icon from '../../../components/AppIcon';

const PromptSummaryCard = ({ prompt, projectType, techStack }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="FileText" size={20} className="text-primary" />
        <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground">
          Project Summary
        </h3>
      </div>
      <div className="space-y-4">
        <div>
          <label className="text-xs md:text-sm font-medium text-muted-foreground mb-2 block">
            Your Prompt
          </label>
          <div className="bg-muted/50 rounded-md p-3 md:p-4">
            <p className="text-sm md:text-base text-foreground line-clamp-3">
              {prompt}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="text-xs md:text-sm font-medium text-muted-foreground mb-2 block">
              Project Type
            </label>
            <div className="flex items-center gap-2 bg-primary/10 rounded-md p-3">
              <Icon name="Layers" size={16} className="text-primary" />
              <span className="text-sm md:text-base font-medium text-foreground">
                {projectType}
              </span>
            </div>
          </div>

          <div>
            <label className="text-xs md:text-sm font-medium text-muted-foreground mb-2 block">
              Technology Stack
            </label>
            <div className="flex flex-wrap gap-2">
              {techStack?.map((tech, index) => (
                <span
                  key={index}
                  className="px-3 py-1 bg-accent/10 text-accent rounded-full text-xs md:text-sm font-medium"
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PromptSummaryCard;